import { useNavigate } from "react-router-dom";
import "../styles/DraftGeneratedView.css"; // ✅ FIXED PATH

const DraftGeneratedView = () => {
  const navigate = useNavigate();

  return (
    <div className="generated-container">
      <h2>Generated Draft</h2>
      <p className="subtitle">Draft generation completed successfully</p>

      <div className="generated-grid">
        <div>
          <span>Identifier</span>
          PDC101
        </div>

        <div>
          <span>Title</span>
          Patent Draft Title 1
        </div>

        <div>
          <span>Created By</span>
          Admin
        </div>

        <div>
          <span>Created Date</span>
          1/9/2026 10:00
        </div>

        <div>
          <span>Input File</span>
          input.xlsx
        </div>

        <div>
          <span>Template File</span>
          draft_temp.docx
        </div>

        <div>
          <span>Output Folder</span>
          C:/downloads
        </div>

        <div>
          <span>Document Scope</span>
          Whole Document
        </div>

        <div>
          <span>Status</span>
          Completed
        </div>
      </div>

      <div className="generated-actions">
        <button className="secondary-btn" onClick={() => navigate("/admin")}>
          Back to Drafts
        </button>

        <button className="primary-btn">
          Download Draft
        </button>
      </div>
    </div>
  );
};

export default DraftGeneratedView;
